import { render, staticRenderFns } from "./GoogleAuthorization.vue?vue&type=template&id=22e92726&scoped=true"
import script from "./GoogleAuthorization.vue?vue&type=script&lang=js"
export * from "./GoogleAuthorization.vue?vue&type=script&lang=js"
import style0 from "./GoogleAuthorization.vue?vue&type=style&index=0&id=22e92726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e92726",
  null
  
)

export default component.exports